import ModalSectionView from "../../modal/view/section";

import {
  MODAL_HEADING_TEXT,
  BUTTON_TEXT
} from "../lexicon.js";

const createModalSectionTemplate = () => {
  return (
    `<section class="captcha-modal-section">
        <div class="captcha-modal">
          <h3 class="heading heading_h3 captcha-modal-heading">${MODAL_HEADING_TEXT}</h3>
          <button class="button button_captcha">${BUTTON_TEXT}</button>
        </div>
    </section>`
  );
};


export default class ModalCaptchaSection extends ModalSectionView {
  constructor() {
    super();

    this._closeButtonClass = `button_captcha`;
    this._createModalSectionTemplate = createModalSectionTemplate;

    this._wrapperElement = null;
    this._applyButtonElement = null;

    this._applyButtonClickHandler = this._applyButtonClickHandler.bind(this);
  }

  getTemplate() {
    return this._createModalSectionTemplate();
  }

  getWrapperElement() {
    return document.querySelector(`.captcha-modal-wrapper`);
  }

  getApplyButtonElement() {
    if (!this._applyButtonElement) {
      this._applyButtonElement = this.getWrapperElement().querySelector(`.button_captcha`);
    }

    return this._applyButtonElement;
  }

  setApplyButtonClickHandler(callback) {
    this._callback.applyButtonClick = callback;
    this.getApplyButtonElement().addEventListener(`click`, this._applyButtonClickHandler);
  }

  _applyButtonClickHandler() {
    this._callback.applyButtonClick();
  }
}
